/*
Summary:
The HistoryDial is a "needle" similar to analog radios. Its purpose is to display
the current position in time. It is largely a visual only component. The 
DateDisplay is broken into two parts, a container (for visual styling) and a
fragment with the transformed date (and calculation logic). This is done to 
prevent unsightly style updates on the container as the value within rapidly
updates.
*/

// TODO: Memoize either dial or DateDisplay to only refresh on scroll, currentDate, or granularity, etc.

import React from "react";
import { useSelector } from "react-redux";
import bigInt from "big-integer";
import { useTime } from "../_contexts";
import { ChronosDate } from "../_helpers";

export function HistoryDial({ displayUnits, calendar, granularity }) {
  // console.group("History Dial Render");
  const { scrollPosition, currentDate } = useTime(); //Need Granularity, Calendar
  const { details: world } = useSelector((state) => state.world);
  // console.groupEnd();
  return (
    <div className="chronicle-history-dial">
      <div className="chronicle-history-display">
        {scrollPosition !== null && currentDate !== null && (
          <span className="chronicle-date-display">
            <DateDisplayText
              position={scrollPosition}
              date={currentDate}
              granularity={granularity}
              calendar={calendar}
              worldTime={world?.worldTime}
              units={displayUnits}
            />
          </span>
        )}
      </div>
    </div>
  );
}

function DateDisplayText({
  position = 0,
  date = "0",
  granularity = "year",
  calendar,
  worldTime,
  units = 1000,
}) {
  // console.group("Date Display Render");
  if (position === null) {
    position = 0;
  }
  if (units === null) {
    units = 1000;
  }
  // console.log("Units (before): ", units);
  // console.group('==== History Dial Text ====');

  // console.log(
  //   'Rendering Date!',
  //   position,
  //   date,
  //   granularity,
  //   worldTime,
  //   calendar,
  //   units
  // );

  const posSuffix =
    worldTime && worldTime.afterZeroAbbr ? worldTime.afterZeroAbbr : "";
  const negSuffix =
    worldTime && worldTime.beforeZeroAbbr ? worldTime.beforeZeroAbbr : "";

  let dateMask = "";
  switch (granularity) {
    case "aeon":
    case "epoch":
    case "myriad":
    case "millenium":
    case "century":
    case "decade":
    case "year":
      dateMask = "$YYYY$";
      break;
    case "day":
      dateMask = "$DD$ $MMMM$ $YYYY$";
      break;
    default:
      dateMask = "$DD$ $MMMM$ $YYYY$";
      break;
  }

  const unitsToCurrent = Math.floor(position / 15);

  // console.log("date", date.slice());
  // console.log("Units to Add", unitsToCurrent);
  // console.log("g", granularity, "u", units);
  let currentDate = new ChronosDate(date, { calendar });
  let segmentDate = currentDate.getTimelineSegment(granularity, {
    unitCountDisplay: units,
  });
  // console.log("Segment in Dial", segmentDate);

  const durationToAdd = getDuration(
    // date,
    segmentDate.start,
    unitsToCurrent,
    // units,
    granularity,
    calendar
  );
  // console.log("----- block");
  const newDateStr = bigInt(segmentDate.start).plus(durationToAdd).toString();
  // console.log("Duration to Add", durationToAdd, " result: ", newDateStr);

  let newDate = new ChronosDate(newDateStr, { calendar });
  // console.log('Positioned Date', newDate.asString(), newDate.toFullObject());

  const result = newDate.format(dateMask, undefined, posSuffix, negSuffix);
  // console.log('Date', newDate.asString(), result);
  // console.groupEnd();
  // console.groupEnd();
  return <span>{result ? result : ""}</span>;
}

function getDuration(date, units, granularity, calendar) {
  // console.group("GETTING DURATION TO ADD", date);
  const newDate = new ChronosDate(date, { calendar });
  let ret = "0";
  switch (granularity) {
    case "day":
    case "hour":
    case "minute": {
      ret = bigInt(units).times(calendar.time[granularity].duration).toString();
      break;
    }

    case "year": {
      // console.group("===Test YEAR==");
      let newDate = new ChronosDate(date, { calendar });

      let newDateObj = newDate.toFullObject();

      newDateObj.year += units;
      // console.log('New Date Object', { ...newDateObj });

      let newDateStr = newDate.setDateFromObject(newDateObj);
      ret = bigInt(newDateStr).minus(date).toString();
      // console.log("newDateString", newDateStr);
      // console.log("ret", ret);
      // console.groupEnd();
      // console.log(
      //   'SET DATE RESULT',
      //   new ChronosDate(newDateStr, { calendar, logSteps: true }).toFullObject()
      // );
      // console.groupEnd();
      // return ret;
      break;
    }

    case "decade":
    case "century":
    case "millenium":
    case "myriad":
    case "epoch":
    case "aeon": {
      // console.group("=== Test ADV ===");
      const unitDuration = calendar.time[granularity].duration;
      const yearsInUnit = bigInt(unitDuration).divide(
        calendar.time.year.duration
      );
      const yearsToAdd = bigInt(units).times(yearsInUnit);
      // console.log("units", units);
      // console.log("yearsInUnit", yearsInUnit);
      // console.log("years to add", yearsToAdd);
      // console.log("Starting date: ", newDate);
      const newDateObject = newDate.toFullObject();
      // console.log("Date object (before)", { ...newDateObject });
      newDateObject.year += yearsToAdd.toJSNumber();

      // console.log("New Date Object", { ...newDateObject });
      let newDateStr = newDate.setDateFromObject(newDateObject);
      ret = bigInt(newDateStr).minus(date).toString();
      // console.log("NewDateString", newDateStr);
      // console.log("ret", ret);
      // console.groupEnd();
      // console.groupEnd();
      // return ret;
      break;
    }
  }
  // console.log("RET RETURNED ", ret);
  // console.groupEnd();
  return ret;
}
